import { AxiosError } from 'axios';
import { RollbarItem } from 'src/types';

export type AxiosResponseToRollbarType = {
  data: {
    response: unknown;
    code: number;
    data: unknown;
  };
};

const isAxiosResponseError = (error: AxiosError | unknown): error is AxiosError => {
  return (error as AxiosError)?.response !== undefined;
};

export const parseErrorToRollbar = (error: AxiosError | unknown): AxiosResponseToRollbarType | { data: unknown } => {
  if (isAxiosResponseError(error)) {
    return {
      data: {
        response: error.response?.data,
        code: error.code,
        data: parseConfigData(error.config?.data),
      },
    };
  }

  return { data: error };
};

export const isFromExtension = (item: RollbarItem): boolean => {
  const filenames = item?.body?.trace?.frames?.map((frame) => frame.filename);
  const message = item?.body?.trace?.exception?.message || '';

  const isExtensionScript = filenames.some((filename) => {
    filename = filename.toLowerCase() || '';
    return (
      filename.includes('chrome-extension://') ||
      filename.includes('moz-extension://') ||
      filename.includes('safari-extension://') ||
      filename.includes('extensions') ||
      filename.includes('script.hotjar') ||
      filename === 'anonymous'
    );
  });

  const isLikelyExtension =
    message.includes('chrome-extension') ||
    message.includes('moz-extension') ||
    message.includes('safari-extension') ||
    message === 'Script error.';

  return isExtensionScript || isLikelyExtension;
};

const parseConfigData = (data) => {
  try {
    return JSON.parse(data);
  } catch (e) {
    return data;
  }
};
